// import HeaderInfo from "./sections/HeaderInfo";
// import TasksSection from "./sections/TasksSection";
// import ImagesSection from "./sections/ImagesSection";
// import FilesSection from "./sections/FilesSection";
// import NotesSection from "./sections/NotesSection";
// import ActivitySection from "./sections/ActivitySection";
// import InvoiceSection from "./sections/InvoiceSection";

import FilesSection from "../FilesSection";
import ActivitySection from "./ActivitySection";
import HeaderInfo from "./HeaderInfo";
import ImagesSection from "./ImagesSection";
import InvoiceSection from "./InvoiceSection";
import NotesSection from "./NotesSection";
import TasksSection from "./TasksSection";

const RightDetails = () => {
  return (
    <>
      <HeaderInfo />
      <TasksSection />
      <ImagesSection />
      <FilesSection />

      <div className="row g-3">
        <div className="col-lg-6">
          <NotesSection />
        </div>
        <div className="col-lg-6">
          <ActivitySection />
        </div>
      </div>

      <InvoiceSection />
    </>
  );
};

export default RightDetails;